import styled from '@emotion/styled'
import { IconButton as MUIIconButton } from '@material-ui/core'
import FiberManualRecord from '@material-ui/icons/FiberManualRecord'
import { colors } from 'Themes/Colors'
import { colors as bsColors } from '@resiliatech/birdsong'

const dimensionColors: { [key: string]: string } = colors

export const Container = styled.li<{ displayStartValue: boolean }>`
  width: 100%;
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr ${({ displayStartValue }) =>
      displayStartValue ? '100px' : ''} auto auto;
`

export const DimensionColor = styled(FiberManualRecord)<{ index: number }>`
  font-size: 18px;
  align-self: center;
  fill: ${({ index }) => dimensionColors[`dimension${index}`]};
`

export const IconButton = styled(MUIIconButton)`
  svg {
    width: 24px;
    height: 24px;
    color: ${bsColors.interactive.primaryEnabled};
  }
`
